export default "__VITE_ASSET__C2D18uJ2__"